import api from "../api";

export interface ResumoControleNaoPrevisto {
    ano: number;
    codigoSolicitacaoTexto: string;
    codigoNaoPrevistoTexto: string;
    tipo: string;
    nomeSolicitante: string;
    nomeResponsavel: string;
    diretoriaSolicitante: string;
    areaSolicitante: string;
    departamentoSolicitante: string;
    codigoProjeto: number;
    numeroTotvs: number;
    nomeProjeto: number;
    total: number;
    motivador: string;
    escopo: string;
    dataUltimoStatus: string;
    status: string;
    dataAbertura: string;
    dataValidacaoCFG: string;
    dataValidacaoADM: string;
    dataValidacaoGPP: string;
    dataAprovacaoSolicitanteGG: string;
    dataAprovacaoSolicitanteDIR: string;
    dataAprovacaoGestaoControleGG: string;
    dataAprovacaoGestaoControleDIR: string;
    dataAprovacaoDiretoriaEstatutariaDS: string;
    dataAprovacaoDiretoriaEstatutariaDF: string;
    dataAprovacaoDiretoriaEstatutariaDP: string;
    dataAprovacaoFinal: string;
    contagemDiasAprovacaoFinal: string;
};

export interface RelatorioProjetosControleNaoPrevisto {
    projetos: ProjetoControleNaoPrevisto[];
    valorTotalOrcado: string;
    valorTotalContratado: string;
    valorTotalExecutado: string;
    valorTotalRequisitado: string;
    valorTotalCompromissado: string;
    valorTotalAContratar: string;
    valorTotalForecast: string;
    valorTotalSaldo: string;
}

export interface ProjetoControleNaoPrevisto {
    key?: string;
    codigoProjeto: string;
    nomeProjeto: string;
    valorOrcado: number;
    valorContratado: number;
    valorExecutado: number;
    valorRequisitado: number;
    valorCompromissado: number;
    valorAContratar: number;
    valorForecast: number;
    valorSaldo: number;
    valorDoacao: number;
    valorTotalDoacoes: number;
    situacaoCor: string;
    children: ProjetoControleNaoPrevisto[];
}

const controller = '/NaoPrevistoControle';

export const getResumoControleNaoPrevisto = async (ano: number) => {
    return await api.get<ResumoControleNaoPrevisto[]>(`${controller}/GetResumoControleNaoPrevisto/${ano}`);
}

export const getProjetosNaoPrevistoControleNaoPrevisto = async (ano: number) => {
    return await api.get<RelatorioProjetosControleNaoPrevisto>(`${controller}/GetProjetosNaoPrevistoControleNaoPrevisto/${ano}`);
}

export const getProjetosDoadoresControleNaoPrevisto = async (ano: number) => {
    return await api.get<ProjetoControleNaoPrevisto[]>(`${controller}/GetProjetosDoadoresControleNaoPrevisto/${ano}`);
}
